import { PermissionsService } from '@services/permissions.service';
import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { UserInfo } from '@models/auth.model';
import { ConfirmModalComponent } from '@components/confirm-modal/confirm-modal.component';
import { copyTextToClipboard } from '@utils/helper';
import { map, of, switchMap } from 'rxjs';
import { BaseService } from '@services/base.service';
import { NavbarService } from '../navbar.service';

@Component({
  selector: 'app-user-info',
  templateUrl: './user-info.component.html',
  styleUrls: ['./user-info.component.scss']
})
export class UserInfoComponent {
  imgAvatar: string;
  userID: number;
  form = new FormGroup(
    {
      fullName: new FormControl(),
      username: new FormControl(),
      address: new FormControl(),
      phoneNumber: new FormControl(),
      role: new FormControl(),
      token: new FormControl(),
    }
  )
  constructor(
    private permissionsService: PermissionsService,
    private dialog: MatDialog,
    private baseService: BaseService,
    private navbarService: NavbarService,
  ) {
  }
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.permissionsService.userInfo.subscribe({
      next: user => {
        this.userID = user.id;
        this.form.patchValue(user);
        this.form.disable();
      }
    })
    this.navbarService.imgAvatar.subscribe({
      next: img => {
        this.imgAvatar = img;
      }
    })
  }

  copyAffiliate() {
    copyTextToClipboard(this.form.get('token').getRawValue());
    this.dialog.open(ConfirmModalComponent, {
      data: {
        title: 'Thành công!',
        content: `Copy link thành công. Dùng tổ hợp Ctrl + C để gửi.`,
        type: 'success',
      },
    });
  }

  onSubmit(f: File) {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return
    }
    this.uploadImage(f)
      .pipe(switchMap(image => this.modifyAvatar(image)))
      .subscribe({
        next: result => {
          this.dialog.open(ConfirmModalComponent, {
            data: {
              title: 'Thành công',
              type: 'success',
              ...result,
            },
          });
        },
      });
  }

  uploadImage(f: File) {
    if (f) {
      const formData = new FormData();
      formData.append('file', f);
      return this.baseService.getUploadFile(formData).pipe(map(x => x.data));
    }
    return of('');
  }

  modifyAvatar(image: string) {
    this.navbarService.imgAvatar.next(image);
    const request = {
      avatar: image
    };
    return this.baseService.getChangeAvatar(this.userID, request).pipe(
      map((result) => ({
        content: 'Thay đổi ảnh đại diện thành công',
      }))
    );
  }
  /**
   * Chọn 1 flie
   */
  handleFileInputChange(l: FileList): void {
    if (l.length) {
      const f = l[0];
      this.onSubmit(f);
    }
  }
}
